<div class="page-wrapper">
  <!-- Page Header -->
  <div class="page-header">
    <h2>Online Eligibility</h2>
    <p>
      To search for a member, select a client and specify ID or enter First Name
      or Last Name
    </p>
    @if (showAddMember) {
      <button mat-stroked-button rounded class="add-new-member" color="accent"
        (click)="addNewMember()">
        Add a New Cardholder
      </button>
    }
  </div>
  <!-- Form Section -->
  <form [formGroup]="searchMemberFormGroup">
    <div class="form-wrapper">
      <div class="mat-row">
        <div class="mat-12">
          <mat-label>Client<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-select">
            <mat-select formControlName="client" placeholder="Select Client"
              (selectionChange)="onSelectionChange($event)" [disableOptionCentering]="true">
              <mat-option>
                <ngx-mat-select-search [formControl]="clientFilterControl" [clearSearchInput]="true"
                  [showToggleAllCheckbox]="false" placeholderLabel="Search Client(s) by ID or Name..."
                  noItemsLabel="No clients found">
                </ngx-mat-select-search>
              </mat-option>
              @if ((filteredClients | async)?.length === 0) {
                <mat-option disabled>
                  No clients found
                </mat-option>
              }
              @for (client of filteredClients | async; track client) {
                <mat-option [value]="client.clientId">
                  {{ client.clientId }} - {{ client.clientName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="searchMemberFormGroup" [isCheckTouch]="checkTouchForForm"
          controlName="client"></app-custom-mat-hint>
        </div>
      </div>
    </div>

    <!-- Search by -->
    <div class="search-by-container">
      <h4 class="sec-heading-no-margin">Search By</h4>
      <div class="custom-tab mat-custom-tab">
        <mat-tab-group (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="eligibilityService.selectedIndex"
          animationDuration="0ms">
          <mat-tab label="Card/Alt ID or SSN"> </mat-tab>
          <mat-tab label="First or Last Name"> </mat-tab>
        </mat-tab-group>

        <!--Form-->

        <div class="tab-action-group mat-row pad-b-0">
          @if (eligibilityService.selectedIndex === 0) {
            <div class="mat-3 pad-r-1">
              <mat-label class="flex">ID Type
                <div class="popover">
                  <mat-icon class="info-icon">info</mat-icon>
                  <div class="popover-container">
                    <div class="flex mb-3">
                      <div class="w-30 text-right">
                        <b>Card/Alt ID</b>
                      </div>
                      <div class="w-70 pl-2">
                        A unique identifier assigned to each user's insurance
                        card.
                      </div>
                    </div>
                    <div class="flex mb-3">
                      <div class="w-30 text-right">
                        <b>SSN</b>
                      </div>
                      <div class="w-70 pl-2">
                        A unique nine-digit Social Security Number.
                      </div>
                    </div>
                    <!-- <div *ngIf="isInternalUser$ | async" class="flex mb-3">
                    <div class="w-30 text-right">
                      <b>EmpiRx Member ID</b>
                    </div>
                    <div class="w-70 pl-2">
                      A unique identifier for a specific member in the system.
                    </div>
                  </div> -->
                  <div class="flex mb-3">
                    <div class="w-30 text-right">
                      <b>Client Internal Member ID</b>
                    </div>
                    <div class="w-70 pl-2">
                      A unique identifier for the member for the internal use.
                    </div>
                  </div>
                  <!-- <div class="flex">
                  <div class="w-30 text-right">
                    <b>Patient ID</b>
                  </div>
                  <div class="w-70 pl-2">
                    Unique identifier for each patient in the system.
                  </div>
                </div> -->
              </div>
            </div>
          </mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-select">
            <mat-select formControlName="idType" placeholder="Enter ID Type"
              (selectionChange)="onChangeIdType($event)" matNativeControl placeholder="Enter ID Type">
              @for (item of idTypes; track item) {
                <mat-option [value]="item">
                  {{ item }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="searchMemberFormGroup" [isCheckTouch]="checkTouchForForm"
          controlName="idType"></app-custom-mat-hint>
        </div>
        <div class="mat-3 pad-r-1">
          <mat-label>ID Number</mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            @if (
              searchMemberFormGroup.controls['idType'].value !== 'SSN'
              ) {
              <input matInput formControlName="idValue" placeholder="Enter ID Number" />
            }
            @if (
              searchMemberFormGroup.controls['idType'].value === 'SSN'
              ) {
              <input matInput appSsnFormat formControlName="idValue" placeholder="Enter ID Number" />
            }
          </mat-form-field>
          <app-custom-mat-hint [formGroup]="searchMemberFormGroup" [isCheckTouch]="checkTouchForForm"
          controlName="idValue"></app-custom-mat-hint>
          @if (
            searchMemberFormGroup.controls['idType'].value ===
            'Card/Alt ID' &&
            searchMemberFormGroup.value.client === '19121'
            ) {
            <mat-hint class="text-danger title-11">
              Please do not enter UNE in the Card ID field. Enter the
              characters that appear after UNE.
            </mat-hint>
          }
        </div>
      }

      @if (eligibilityService.selectedIndex === 1) {
        <div class="mat-3 pad-r-1">
          <mat-label>First Name</mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            <input matInput formControlName="firstName" placeholder="Enter First Name" value="" />
          </mat-form-field>
        </div>
        <div class="mat-3 pad-r-1">
          <mat-label>Last Name</mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-input">
            <input matInput formControlName="lastName" placeholder="Enter Last Name" value="" />
          </mat-form-field>
        </div>
      }

      <div class="mat-5">
        <div class="action-btn-group">
          <button mat-button class="primary-btn" [disabled]="!isValidForm()"
            (click)="checkTouchForForm = true; searchMembers()">
            Search
          </button>
          <button mat-button class="secondary-btn" (click)="resetForm()"
            [ngClass]="{ 'disabled-btn': allFieldsEmpty }">
            Reset
          </button>
        </div>
      </div>
    </div>

    <mat-divider></mat-divider>
  </div>
</div>
</form>

<!-- Accordion Table -->

@if (members$ | async; as members) {
  @if (dataLoaded && searchClicked) {
    <div class="accordion-table-filter">
      <h4 class="form-heading">{{ totalLength }} Results Found</h4>
      <button mat-button (click)="toggle()" class="expand-collapse-button">
        Expand/Collapse All
      </button>
    </div>
    <div class="accordion-table">
      <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8 member-search-table">
        <!--['personCode','firstName', 'lastName', 'cardId', 'menuOptions', 'expandIcon' ];-->
        <ng-container matColumnDef="personCode">
          <th mat-header-cell *matHeaderCellDef width="50">Person Code</th>
          <td mat-cell *matCellDef="let element">
              <div [ngClass]="{
              'person-code-coverage-expired': checkIfCoverageExpired(element),
              'person-code-coverage-active': checkIfCoverageIsStartingSoon(element),
              'person-code-coverage-soft-deleted': checkIfCoverageSoftDeleted(element)
            }">{{ element.personCode }}</div>
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef width="130">Name</th>
          <td mat-cell *matCellDef="let element">
            {{ element.firstName }} {{ element.lastName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="namecopy">
          <th mat-header-cell *matHeaderCellDef width="20">&nbsp;</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="small-icon-btn" [cdkCopyToClipboard]="copyFirstNameLastName(element)"
              aria-label="Copy">
              <mat-icon matTooltip="Copy Name">content_copy</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="DOB">
          <th mat-header-cell *matHeaderCellDef width="80">DOB</th>
          <td mat-cell *matCellDef="let element">
            {{ element.DOB | timeStampToDate }}
          </td>
        </ng-container>
        <ng-container matColumnDef="dobcopy">
          <th mat-header-cell *matHeaderCellDef width="20">&nbsp;</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="small-icon-btn" [cdkCopyToClipboard]="element.DOB | timeStampToDate"
              aria-label="Copy">
              <mat-icon matTooltip="Copy DOB">content_copy</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="cardId">
          <th mat-header-cell *matHeaderCellDef width="90">Card ID</th>
          <td mat-cell *matCellDef="let element">
            {{ element.cardId }}
          </td>
        </ng-container>
        <ng-container matColumnDef="cardidcopy">
          <th mat-header-cell *matHeaderCellDef width="20">&nbsp;</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="small-icon-btn" [cdkCopyToClipboard]="element.cardId" aria-label="Copy">
              <mat-icon matTooltip="Copy Card ID">content_copy</mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="relationShipCode">
          <th mat-header-cell *matHeaderCellDef width="220">Relationship</th>
          <td mat-cell *matCellDef="let element">
            <div style="width: 120px;">{{ element.relationshipCode }} - {{ relationShip[element.relationshipCode] }}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="clientInternalMemberId">
          <th mat-header-cell *matHeaderCellDef width="130">Client Internal Member ID</th>
          <td mat-cell *matCellDef="let element">
            {{
            element.clientInternalMemberId
            ? element.clientInternalMemberId
            : "-"
            }}
          </td>
        </ng-container>
        <ng-container matColumnDef="PMartProfileStatus">
          <th mat-header-cell *matHeaderCellDef width="220">Mail Order Profile Status</th>
          <td mat-cell *matCellDef="let element">
            @if ((element.mailOrderProfileStatus | async); as regStatus) {
              <div>
                {{ regStatus }}
              </div>
            } @else {
              <div class="field-loader">
                <div class="loading-bar"></div>
              </div>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="menuOptions">
          <th class="text-right pad-r-1" mat-header-cell *matHeaderCellDef>
            Actions
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="flex" fxLayout="row" fxLayoutAlign="end center" class="relative-action">
              @if (checkMenuAccess(element, 'AddNewDependent')) {
                <mat-icon class="add-user" matTooltip="Add New Dependent"
                (click)="addNewDependent(element)"></mat-icon>
              }
              @if (checkMenuAccess(element, 'UpdateMember')) {
                <mat-icon class="edit-user" [matTooltip]="getToolTip()"
                (click)="updateMember(element)"></mat-icon>
              }
              <div class="menu">
                @if (getMenuOptions(element).length) {
                  <button matTooltip="View all actions" mat-icon-button
                    [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                }
                <mat-menu class="custom-menu" #menu="matMenu">
                  @for (menu of getMenuOptions(element); track menu) {
                    <button mat-menu-item (click)="goToMenu(menu, element)">
                      {{ menu.displayName }}
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="expandIcon">
          <th mat-header-cell *matHeaderCellDef class="th-acc-expand"></th>
          <td mat-cell *matCellDef="let element">
              <mat-icon (click)="
                  expandedElement =
                    expandedElement === element ? null : element;
                  allRowsExpanded = allRowsExpanded ? false : allRowsExpanded
                " class="down-arrow acc-expand-icon">expand_more</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" [ngClass]="{
              'coverage-expand-expired-active': checkIfCoverageExpired(element),
              'coverage-expand-start-active': checkIfCoverageIsStartingSoon(element),
              'coverage-soft-deleted-expand-active ': checkIfCoverageSoftDeleted(element)
            }">
              <div class="example-element-detail" [@detailExpand]="
                  element == expandedElement || allRowsExpanded
                    ? 'expanded'
                    : 'collapsed'
                ">
              <div class="custom-tab w-100 mat-custom-tab" style="margin-left: -6px">
                <mat-tab-group animationDuration="0ms">
                  @if (element) {
                    <mat-tab label="Personal">
                      <div class="pad-1">
                        <div class="flex flex-wrap">
                          <div class="read-only w-25">
                            <p>SSN</p>
                            <h4>
                              {{
                              element.SSN ? formatSSNString(element.SSN) : "-"
                              }}
                            </h4>
                          </div>
                          <div class="read-only w-25">
                            <p>Gender</p>
                            <h4>{{ displayGender[element.gender] }}</h4>
                          </div>
                          <div class="read-only w-25">
                            <p>Patient ID</p>
                            <h4>
                              {{ element.patientId ? element.patientId : "-" }}
                            </h4>
                          </div>
                          <div class="read-only w-25">
                            <p>Coverage Type</p>
                            <h4>
                              {{
                              element.coverage?.coverageType
                              ? element.coverage?.coverageType
                              : "-"
                              }}
                            </h4>
                          </div>
                          <div class="read-only w-25">
                            <p>Mail Order Profile Status</p>
                            <h4>
                              {{element?.mailOrderRegStatus}}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                  }
                  @if (element) {
                    <mat-tab label="Address">
                      <div class="pad-1">
                        <div class="flex flex-wrap">
                          <div class="read-only w-25">
                            <p>Address Line 1</p>
                            <h4>
                              {{
                              element.addressLine1
                              ? element.addressLine1
                              : "-"
                              }}
                            </h4>
                          </div>
                          <div class="read-only w-25">
                            <p>Address Line 2</p>
                            <h4>
                              {{
                              element.addressLine2
                              ? element.addressLine2
                              : "-"
                              }}
                            </h4>
                          </div>
                          <div class="read-only w-25">
                            <p>City</p>
                            <h4>{{ element.city ? element.city : "-" }}</h4>
                          </div>
                          <div class="read-only w-25">
                            <p>State</p>
                            <h4>{{ element.state ? element.state : "-" }}</h4>
                          </div>
                          <div class="read-only w-25">
                            <p>Zip code</p>
                            <h4>
                              {{ element.zipCode ? element.zipCode : "-" }}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                  }
                  @if (element) {
                    <mat-tab label="Contact">
                      <div class="pad-1">
                        <div class="flex flex-wrap">
                          @for (phone of element.phones; track phone) {
                            <div class="read-only w-25">
                              @if (phone.type === 'workPhone') {
                                <p>Work Phone</p>
                              }
                              @if (phone.type === 'cellPhone') {
                                <p>Cell Phone</p>
                              }
                              @if (phone.type === 'homePhone') {
                                <p>Home Phone</p>
                              }
                              <h4>
                                {{
                                phone.phoneNumber &&
                                phone.phoneNumber !== "null"
                                ? formatPhoneNumber(phone.phoneNumber)
                                : "-"
                                }}
                              </h4>
                            </div>
                          }
                        </div>
                      </div>
                    </mat-tab>
                  }
                  @if (element) {
                    <mat-tab label="Coverage">
                      @if (
                        element.coverageHistory$ | async; as coverageHistory
                        ) {
                        <div class="pad-1">
                        <table mat-table [dataSource]="
                            getCoverageTableDatasource(coverageHistory)
                          " multiTemplateDataRows class="coverage-table">
                            <ng-container matColumnDef="group">
                              <th mat-header-cell *matHeaderCellDef>Group</th>
                              <td mat-cell *matCellDef="let element">
                                {{element.groupId }}: {{element.groupName }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="client">
                              <th mat-header-cell *matHeaderCellDef>Client</th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.clientName }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="effectiveDate">
                              <th mat-header-cell *matHeaderCellDef>
                                Effective Date
                              </th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.startDate }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="endDate">
                              <th mat-header-cell *matHeaderCellDef>End Date</th>
                              <td mat-cell *matCellDef="let element">
                                {{ element.endDate }}
                              </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                              <th mat-header-cell *matHeaderCellDef>Status</th>
                              <td mat-cell *matCellDef="let element">
                                <div class="coverage-status">
                                  <span class="{{ displayCoverageStatus[element.eligibilityIndicator]?.class }}"></span>
                                  {{ displayCoverageStatus[element.eligibilityIndicator]?.name }}
                                </div>
                              </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="coverageTableColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: coverageTableColumns"></tr>
                            <tr class="mat-row no-data-row" *matNoDataRow>
                              <td class="mat-cell" colspan="12" role="status">
                                No Data Found
                              </td>
                            </tr>
                          </table>
                        </div>
                      }
                    </mat-tab>
                  }
                  @if (element) {
                    <mat-tab label="Coverage Types">
                      <div class="pad-1">
                        <table mat-table [dataSource]="getCoverageTypesTableDatasource(element)" multiTemplateDataRows
                          class="coverage-table">
                          <ng-container matColumnDef="memberRxType">
                            <th mat-header-cell *matHeaderCellDef>Coverage Type</th>
                            <td mat-cell *matCellDef="let element">
                              {{ coverageTypes[element.flexTagName]}}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="effectiveDate">
                            <th mat-header-cell *matHeaderCellDef>Effective Date</th>
                            <td mat-cell *matCellDef="let element">
                              {{ element.flexTagStartDate | timeStampToDate }}
                            </td>
                          </ng-container>
                          <ng-container matColumnDef="endDate">
                            <th mat-header-cell *matHeaderCellDef>End Date</th>
                            <td mat-cell *matCellDef="let element">
                              {{ element.flexTagEndDate | timeStampToDate }}
                            </td>
                          </ng-container>
                          <tr mat-header-row *matHeaderRowDef="coverageTypesDisplayedColumns"></tr>
                          <tr mat-row *matRowDef="let row; columns: coverageTypesDisplayedColumns"></tr>
                          <tr class="mat-row no-data-row" *matNoDataRow>
                            <td class="mat-cell" colspan="12" role="status">
                              No Data Found
                            </td>
                          </tr>
                        </table>
                      </div>
                    </mat-tab>
                  }
                  <!-- *ngIf="element && element.personCode === '01'" -->
                  @if (
                    element && element.relationshipCode === cardHolderRC  ) {
                    <mat-tab label="ID Requests">
                      @if (element.idRequests$ | async; as idRequests) {
                        <div class="pad-1">
                          <div class="flex flex-wrap">
                            @if (idRequests.length === 0) {
                              <div class="read-only w-30">
                                <p>No requests available</p>
                              </div>
                            }
                            @if (idRequests.length > 0) {
                              <div class="read-only w-30">
                                <p>List of dates</p>
                                <ul>
                                  @for (reqDate of idRequests; track reqDate) {
                                    <li>
                                      {{ reqDate | timeStampToDate }}
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </mat-tab>
                  }
                </mat-tab-group>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns" [ngClass]="{
              'coverage-expired-active': checkIfCoverageExpired(element),
              'coverage-start-active': checkIfCoverageIsStartingSoon(element),
              'coverage-soft-deleted': checkIfCoverageSoftDeleted(element)
            }" class="example-element-row" [class.example-expanded-row]="expandedElement === element"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
        <tr tabindex="0" class="mat-row no-data-row" *matNoDataRow>
          <td class="mat-cell" colspan="12" role="status">No Data Found</td>
        </tr>
      </table>
      <div class="accordion-table-footer" [hidden]="hidePaginator">
        <div class="legends">
          <div class="legends-item">
            <span class="cs-legend"></span>
            Coverage Starting Soon
          </div>
          <div class="legends-item">
            <span class="ce-legend"></span>
            Coverage Expired
          </div>
          <div class="legends-item">
            <span class="cd-legend"></span>
            Soft Deleted
          </div>
        </div>
        <mat-paginator #paginator (page)="onPageChange($event)" [pageSize]="10" [pageIndex]="currentPageIndex"
        [length]="totalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
  }
}
</div>